import PropTypes from 'prop-types';
import Modal from './ModalRelative';

export default function PhotoIntegrityFailReasons(props) {
    const contentRowStyle = {
        marginTop: '0px',
        display: 'grid',
        gridTemplateColumns: '100%',
    };
    const contentLabelStyle = { fontSize: '12px' };
    const contentLabelInvalidStyle = { ...contentLabelStyle, color: '#e63232' };
    const photoIntegrity = props.photoIntegrity; // work_order only.
    const failedReasons = [
        ...(photoIntegrity?.validateCreationDate?.failReasons || []),
        ...(photoIntegrity?.validateLocation?.failReasons || []),
        ...(photoIntegrity?.validateDuplication?.failReasons || []),
    ];
    return (
        <div>
            <Modal
                controlId='photo-integrity-fail-reason-modal'
                contentLabel='photo-integrity-fail-reason-modal'
                onCloseClick={props.handleCloseOnClick}
                showClose
                header='Photo Integrity Failure Reasons'
                style={{ ...props.style, width: '350px', position: 'absolute' }}
            >
                <div style={contentRowStyle}>
                    {failedReasons.map(reason => (
                        <div style={contentLabelInvalidStyle}>{reason}</div>
                    ))}
                </div>
            </Modal>
        </div>
    );
}
PhotoIntegrityFailReasons.propTypes = {
    handleCloseOnClick: PropTypes.func.isRequired,
    photoIntegrity: PropTypes.shape({
        validateCreationDate: PropTypes.shape({
            failReasons: PropTypes.arrayOf(PropTypes.string),
        }),
        validateLocation: PropTypes.shape({
            failReasons: PropTypes.arrayOf(PropTypes.string),
        }),
        validateDuplication: PropTypes.shape({
            failReasons: PropTypes.arrayOf(PropTypes.string),
        }),
    }),
    style: PropTypes.shape({}),
};
